// Entity relational fields to include when soft deleting

export const EQUIPMENT_RELATIONAL_FIELDS = [
  "project_id",
  "system_group_id",
  "system_id",
  "location_id",
];

export const CABLE_RELATIONAL_FIELDS = [
  "project_id",
  "system_group_id",
  "system_id",
  "source_section_id",
  "destination_section_id",
  "cable_bundle_id",
];

export const SECTION_RELATIONAL_FIELDS = [
  "system_group_id",
  "system_id",
  "equipment_id",
];

export const SYSTEM_RELATIONAL_FIELDS = [
  "system_group_id",
];

export const ORDER_RELATIONAL_FIELDS = [
  "project_id",
];
